define.alias("shared/modifiers/show-in-viewport", "settings/modifiers/show-in-viewport");